import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=d25fe6ce&scoped=true"
import script from "./BankEdit.vue?vue&type=script&lang=ts"
export * from "./BankEdit.vue?vue&type=script&lang=ts"
import style0 from "./BankEdit.vue?vue&type=style&index=0&id=d25fe6ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25fe6ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d25fe6ce')) {
      api.createRecord('d25fe6ce', component.options)
    } else {
      api.reload('d25fe6ce', component.options)
    }
    module.hot.accept("./BankEdit.vue?vue&type=template&id=d25fe6ce&scoped=true", function () {
      api.rerender('d25fe6ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/BankEdit.vue"
export default component.exports